import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_CHALLENGE_IMAGE_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateChallengeImageDetailsArgs } from '../graphql/transformers'
import { UPDATE_CHALLENGE_IMAGE_DETAILS } from '../redux/action-types'

const useUpdateChallengeImageDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isImageDetailsLoading, imageDetailsError } = useSelector(
    store => store.challenges.challenge,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_CHALLENGE_IMAGE_DETAILS_MUTATION,
        { id, data: transformToUpdateChallengeImageDetailsArgs(data) },
        dispatch,
        UPDATE_CHALLENGE_IMAGE_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    { isLoading: isImageDetailsLoading, error: imageDetailsError },
  ]
}

export default useUpdateChallengeImageDetailsMutation
